<template>
  <div class="content-container">
    <search-comp @onSearch="fnSearchGroupList" @onReset="onReset">
      <div class="section-box">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col w-25">
                <div class="das-form-input">
                  <div class="label">Thông tin đoàn</div>
                  <div class="child-w-80">
                    <input
                      v-model="searchParams.info"
                      type="text"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="das-form-col w-10">
                <div class="das-form-input">
                  <div class="label">Từ ngày</div>
                  <div class="child-w-80">
                    <CalendarSelect
                      v-model="searchParams.fromDate"
                      style="display: block"
                      mode="date"
                    />
                  </div>
                </div>
              </div>
              <div class="das-form-col w-10">
                <div class="das-form-input">
                  <div class="label">Đến ngày</div>
                  <div class="child-w-80">
                    <CalendarSelect
                      v-model="searchParams.toDate"
                      style="display: block"
                      mode="date"
                    />
                  </div>
                </div>
              </div> -->
              <div class="das-form-col w-20">
                <div class="das-form-input">
                  <div class="label">Ngày nhả phòng</div>
                  <div class="child-w-80">
                    <CalendarRange
                      v-model="releaseDate"
                      style="display: block; width: 100%"
                      mode="date"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="das-form-container">
      <div class="das-form-title-container justify-space-between">
        <div class="das-form-title">
          <span class="main-title">Đoàn đã nhả phòng</span>
        </div>
      </div>
    </div>

    <hr />
    <div v-loading="masterGroupLoading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        dom-layout="scroll"
        :auto-size-cell="true"
        class="agGrid"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="masterGroupTable"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers">
      <button class="btn primary small" @click="showFunction">
        Hiện chức năng
      </button>
      <button class="btn primary small" @click="fnExportExcel">
        Xuất Excel
      </button>
    </div>
  </div>
</template>

<script>
// import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
// import paginationMixin from '@/mixins/paginationMixin'
import { getBookingGroupListApi } from '@/api/booking_service/bookingGroupApi'
import { getListAgentToExcelApi } from '@/api/booking_service/bookingGroup'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
export default {
  components: {
    // CalendarSelect,
    CalendarRange
  },
  // mixins: [paginationMixin],
  data() {
    return {
      masterGroupLoading: false,
      columns: [
        {
          headerName: 'Mã đoàn',
          tooltipField: 'booking_code',
          field: 'booking_code'
        },
        {
          headerName: 'Tên đoàn',
          tooltipField: 'name',
          field: 'name'
        },
        {
          headerName: 'Đại lý du lịch',
          headerTooltip: 'Đại lý du lịch',
          tooltipField: 'agent_name',
          // headerClass: 'ag-grid-header-cell-border-bottom',
          field: 'agent_name'
        },
        {
          headerName: 'Ngày đến đầu',
          headerTooltip: 'Ngày đến đầu',
          tooltipField: 'first_arrival_date',
          // headerClass: 'ag-grid-header-cell-border-bottom',
          field: 'first_arrival_date'
        },
        {
          headerName: 'Ngày đi cuối',
          headerTooltip: 'Ngày đi cuối',
          tooltipField: 'last_departure_date',
          field: 'last_departure_date'
        },
        {
          headerName: 'Ngày nhà phòng',
          headerTooltip: 'Ngày nhà phòng',
          tooltipField: 'sub_transacrelease_datetion_code',
          field: 'release_date'
        },
        {
          headerName: 'Ghi chú',
          tooltipField: 'note',
          field: 'note'
        },
        {
          headerName: 'Liên hệ',
          tooltipField: 'contact',
          field: 'contact'
        }
      ],
      rows: [],
      searchParams: {
        info: null,
        // fromDate: null,
        // toDate: null,
        releaseDateFrom: null,
        releaseDateTo: null,
        pageSize: 10,
        pageNum: 1
      },
      searchParamsDefault: {
        info: null,
        // fromDate: null,
        // toDate: null,
        releaseDateFrom: null,
        releaseDateTo: null,
        pageSize: 10,
        pageNum: 1
      },
      pageParams: {
        totalPage: 0,
        currentPage: 0
      }
    }
  },
  computed: {
    releaseDate: {
      get() {
        return {
          start: this.searchParams.releaseDateFrom,
          end: this.searchParams.releaseDateTo
        }
      },
      set(newValue) {
        this.searchParams.releaseDateFrom = newValue.start
        this.searchParams.releaseDateTo = newValue.end
      }
    }
  },
  mounted() {
    this.fnSearchGroupList()
  },
  methods: {
    showFunction() {
      this.$router.push('/group/group_master_functions')
    },
    async fnGetReleaseGroup() {},
    async fnSearchGroupList() {
      this.masterGroupLoading = true

      await getBookingGroupListApi(this.searchParams)
        .then(res => {
          this.rows = res.data
          this.pageParams.totalPage = Math.ceil(
            res.total / this.searchParams.pageSize
          )
          this.pageParams.currentPage = this.searchParams.pageNum
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.masterGroupLoading = false
        })
    },
    onReset() {
      this.searchParams = Object.assign(
        this.searchParams,
        this.searchParamsDefault
      )
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.fnSearchGroupList()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.fnSearchGroupList()
    },
    fnExportExcel() {
      // alert('export excel')
      var date = this.$moment().format('DD-MM-YY')
      getListAgentToExcelApi(this.searchParams)
        .then(res => {
          if (!res.is_error) {
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'LIST_RELEASE_GROUP_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.w-10 {
  width: 10%;
}
.w-20 {
  width: 20%;
}
.w-25 {
  width: 25%;
}
.w-30 {
  width: 30%;
}
</style>
